export enum CardState {
  Undrawn, Unrevealed, Revealed
}
